import React from "react";
import SubPageContainer from "components/templates/SubPageContainer";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import OptionCard from "components/atoms/OptionCard";
import Sites from "draws/home/Sites";

import { linkUff, linkIcex, linkIchs } from "links/links";

const href = (link) => {
  return (window.location.href = link);
};

const Fields = () => {
  const handleClickUFF = () => {
    href(linkUff);
  };

  const handleClickIcex = () => {
    href(linkIcex);
  };

  const handleClickIchs = () => {
    href(linkIchs);
  };

  return (
    <>
      <Box
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Grid container spacing={2} width={{ xs: 300, sm: 604, md: 906 }}>
          <Grid item xs={12} sm={6} md={4}>
            <OptionCard
              title="UFF"
              description="Site da Universidade"
              image={<Sites />}
              action={handleClickUFF}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <OptionCard
              title="ICEx"
              description="Site do instituto"
              image={<Sites />}
              action={handleClickIcex}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <OptionCard
              title="ICHS"
              description="Site do instituto"
              image={<Sites />}
              action={handleClickIchs}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

const Home = () => {
  return (
    <SubPageContainer>
      <Fields />
    </SubPageContainer>
  );
};

export default Home;
